import { RenderHtml } from '@flos/react-components';
import { IAppConfig } from '../../common/interface/IAppConfig';
import { baseStyles } from '../../theme/base.styles';

type ReceiptTextProps = {
    config: IAppConfig;
};

export const ReceiptText = ({ config }: ReceiptTextProps) => {
    const content = config.resourceBundles['onsa.travel.receipt'].read();
    const receiptText = config.contentBlocks['onsa.travel.receipt'].read();
    const baseClasses = baseStyles();
    return (
        <>
            <RenderHtml html={receiptText.data} className={baseClasses.htmlWrapper} />
            <div>
                <h5>{content['sub.heading']}</h5>
                <ul className="List">
                    <li>{content['list.item.1']}</li>
                </ul>
                <h3>{content['main.heading']}</h3>
            </div>
        </>
    );
};
